import { render } from "./CommunityTeamSelect.vue?vue&type=template&id=7bf7c136&ts=true"
import script from "./CommunityTeamSelect.vue?vue&type=script&lang=ts"
export * from "./CommunityTeamSelect.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__